import React from "react";
import { useSelector } from "react-redux";

import dayjs from "@/lib/helpers/dayjs";
import { getUsernameFromToken } from "@/redux/actions/auth";
import { Portal } from "@/components/Common/Modal/Portal";
import { selectScheduleList } from "@/redux/selectors/patientSelectors";
import { selectShouldShowHCPDIModal } from "@/redux/selectors/authSelectors";
import { useAppendAcknowledgement } from "@/features/consent/api/mutations/useAppendAcknowledgement";

import { DIReminderWidget } from "./Widget/DIReminderWidget";

// TODO: Modernize modal
export function HCPDIReminderModal() {
  const scheduleList = useSelector(selectScheduleList);
  const shouldShowModal = useSelector(selectShouldShowHCPDIModal);
  const { mutate: acknowledge } = useAppendAcknowledgement();

  if (!shouldShowModal || !scheduleList.length) return null;

  const onAcknowledge = () => {
    acknowledge({
      acknowledgement: {
        acknowledged_by: getUsernameFromToken(),
        client: "web",
        date: dayjs.utc().toISOString(),
        timezone: dayjs.tz.guess(),
      },
      acknowledgement_name: "hcp_di_reminder",
    });
  };

  return (
    <Portal
      className="take-assessment-modal"
      headerClass="portal-grey-background"
      headerRender={
        <div className="d-flex flex-column align-items-center w-100 mt-2 tw:justify-center">
          <h5
            className="border-bottom-0 text-align-center fs-lg-20 fs-14 tw:font-bold"
            style={{ color: "#0E3C51" }}
          >
            Welcome to aptihealth!
          </h5>

          <h5
            className="border-bottom-0 text-align-center fs-lg-20 fs-14 tw:font-bold"
            style={{ color: "#0E3C51" }}
          >
            Your first session is coming up.
          </h5>
        </div>
      }
      isBottomCloseActive={false}
      isOpenOnRender={true}
      onModalClose={onAcknowledge}
    >
      <DIReminderWidget call={scheduleList[0]} onSubmit={onAcknowledge} />
    </Portal>
  );
}
